(function () {

    "use strict";
    function basicTaskController($q, entityTaskService, $rootScope) {

        var vm = this;
        vm.$onInit = function () {

        };

        vm.$onChanges = function () {
            vm.load = function (editContoller) {
                vm.entity = editContoller.entity;
                vm.save = editContoller.save;
                vm.loadEntity = editContoller.loadEntity;
                vm.service = editContoller.service;
                vm.getWorkFlowHomologar();
            };
            vm.load(vm.editContoller);
        };

        vm.getWorkFlowHomologar = function () {

            var promises = [];
            var tasKService = entityTaskService.workFlow();
            vm.optionsTaskDatosProducto = [];
            var aprobacionWorkflowDefinition = $rootScope.configApi.workFlows.find(function (item) { return item.customForm === vm.customForm && item.customActivity === vm.customActivity; });
            aprobacionWorkflowDefinition.activities.forEach(function (aprobacionActivity) {
                var getTaskPromise = tasKService.getTask(vm.entity, aprobacionWorkflowDefinition.name, aprobacionActivity.name).then(
                    function (aprobacionTask) {
                        if (aprobacionTask === null) {
                            return;
                        }
                        var optionsTask = JSON.parse(aprobacionTask.options);

                        if (vm.mappVariables) {
                            vm.entity.variables = getMappedRelationsMetadatas(aprobacionTask.typedRelationsMetadatas);
                            vm.entity.isMappedVariables = true;
                        }

                        vm.saveVariables = function () {

                            var defered = $q.defer();
                            var promise = defered.promise;

                            tasKService.saveMetadataTask(vm.entity, aprobacionTask, vm.service.entityService.entityName).then(
                                function () {
                                    defered.resolve();
                                },
                                function (error) {
                                    defered.reject(error);
                                });

                            return promise;
                        };

                        optionsTask.forEach(function (outputOption) {

                            outputOption.action = function () {

                                var defered = $q.defer();
                                var promise = defered.promise;

                                vm.save().then(
                                    function () {
                                        vm.activeOutput = outputOption;
                                        tasKService.outTask(vm.entity, aprobacionTask, outputOption, vm.service.entityService.entityName).then(
                                            function () {
                                                vm.activeOutput = undefined;
                                                vm.loadEntity().then(
                                                    function () {
                                                        vm.getWorkFlowHomologar();
                                                        defered.resolve();
                                                    },
                                                    function (error) {
                                                        defered.reject(error);
                                                    });
                                            },
                                            function (error) {
                                                vm.activeOutput = undefined;
                                                defered.reject(error);
                                            });
                                    },
                                    function (error) {
                                        console.log(error);
                                        defered.reject(error);
                                    });

                                return promise;
                            };
                            vm.optionsTaskDatosProducto.push(outputOption);
                        });
                        return;
                    });
                promises.push(getTaskPromise);
            });

            return $q.all(promises);
        };

        function getMappedRelationsMetadatas(typedRelationsMetadatas) {
            var variables = {};
            typedRelationsMetadatas.forEach(function (variable) {
                variables[variable.name] = variable.value;
            });
            return variables;
        }

    }

    basicTaskController.$inject = ["$q", "solpheo.entityTaskService", "$rootScope"];

    angular.module("sphforms.main")
        .component("sphformsBasicTask", {
            transclude: true,
            controller: basicTaskController,
            bindings: {
                customForm: '<',
                customActivity: '<',
                load: '=',
                editContoller: '<',
                mappVariables: '<',
                saveVariables: '='
            },
            templateUrl: "modules/main/components/basicTask/basicTask.template.html"
        });

}());
